<template>
  <account-select-view>
    <select-binding
      label="login"
      :list="account_list"
      :id="account_id"
      @select="save_account"/>
  </account-select-view>
</template>
<script>

  import {createNamespacedHelpers} from 'vuex';
  import SelectBinding from "../../components/select-binding";
  import {TALENTQ_STORE_NAMES} from "@/stores_new/vacancy_talentq/constants";
  import AccountSelectView from "@/routes_new/inner/vacancy/talentq/components/account/account-select-view";

  const {mapActions, mapGetters} = createNamespacedHelpers('vacancy_talentq/' + TALENTQ_STORE_NAMES.BINDING);

  export default {
    name: "account-select",
    components: {
      AccountSelectView,
      SelectBinding
    },
    props: {
      account_list: {
        type: Object,
        required: true,
      }
    },
    computed: {
      ...mapGetters(['account_id']),
    },
    methods: {
      ...mapActions(['save_account']),
    }
  }
</script>